import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';
import auth from "@/router/middlewares/auth";
import middlewarePipeline from "@/router/middlewarePipeline";
import admin from "@/router/middlewares/admin";
import loggedIn from "@/router/middlewares/loggedIn";
import Dashboard from "@/views/Dashboard";

Vue.use(VueRouter)

const routes = [
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/Contact.vue'),
  },
  {
    path: '/',
    name: 'main',
    component: () => import('../views/Main.vue'),
    meta: {
      middleware: [
        loggedIn
      ]
    }
  },
  {
    path: '/admin',
    component: Dashboard,
    name: 'admin.dashboard',
    redirect: '/admin/parsed',
    meta: {
      middleware: [
        auth,
        admin
      ]
    },
    children: [
      {
        path: '/admin/parsed',
        name: 'admin.inbox',
        component: () => import('../views/Parsed.vue'),
        meta: {
          middleware: [
            auth
          ]
        }
      },
      {
        path: '/admin/parser',
        name: 'admin.parser',
        component: () => import('../views/Parser.vue'),
        meta: {
          middleware: [
            auth
          ]
        }
      },
      {
        path: '/admin/parser/config',
        name: 'admin.parser.config',
        component: () => import('../views/admin/Configure.vue'),
        meta: {
          middleware: [
            auth,
            admin
          ]
        }
      },
      {
        path: '/admin/user/add',
        name: 'admin.user.add',
        component: () => import('../views/admin/User.vue'),
        meta: {
          middleware: [
            auth
          ]
        }
      }
    ]
  },
  {
    path: '/user',
    component: Dashboard,
    name: 'user.dashboard',
    redirect: '/user/parsed',
    meta: {
      middleware: [
        auth
      ]
    },
    children: [
      {
        path: '/user/parsed',
        name: 'user.inbox',
        component: () => import('../views/Parsed.vue'),
        meta: {
          middleware: [
            auth
          ]
        }
      },
      {
        path: '/user/parser',
        name: 'user.parser',
        component: () => import('../views/Parser.vue'),
        meta: {
          middleware: [
            auth
          ]
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('setPageLoading', true).catch()
  if (!to.name.includes('main')) {
    if (to.name.includes('contact')) {
      store.dispatch('setRoute', false).catch()
    } else {
      store.dispatch('setRoute', true).catch()
    }
  } else {
    store.dispatch('setRoute', false).catch()
  }
  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware
  const context = {
    to,
    from,
    next,
    store
  }
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})

router.afterEach(() => {
  setTimeout(() => {
    store.dispatch('setPageLoading', false).catch()
  }, 1500)
})

export default router
